<template>   
  <div id="login">
    <section class="login-container">
      <div class="container">
    <div v-show="loading" class="loading">
      <i  class="fa fa-3x fa-spinner fa-spin"></i>
    </div>        
        <div class="col-md-4 col-md-offset-4 col-sm-4 col-sm-offset-4">
          <div class="login-form-container">
            <div class="login-form-header">
                <div class="logo">
                    <img style="width:120px" src="/static/images/logo-am.png" alt="logo">
                </div>
            </div>            
             <form class="j-forms" id="forms-login" novalidate>
                    <div class="unit" v-if="loginErr">
                      <div class="error-message">
                        <i class="fa fa-close"></i>
                        <p>{{ loginErr }}</p>
                      </div>
                    </div>
                    <div class="unit">
                      <p>Welcome to Audio Modeling Customer Portal</p>
                      <p>Here you can download your purchased products and manage the licences activations on your computers and devices.</p>
                    </div>             
                  <div class="login-form-content">
                    <div class="unit">
                      <h2>Login for Registered Customers</h2>
                    </div>
                      <!-- start login -->                      
                      <div class="unit">
                          <div class="input login-input">
                              <label class="icon-left" for="login">
                                  <i class="zmdi zmdi-account"></i>
                              </label>
                              <input class="form-control login-frm-input"  type="text" id="login" name="login" placeholder="Username / Email" v-model="credentials.username" @keyup.enter="sendPost()" autofocus="autofocus" novalidate>
                          </div>
                      </div>
                      <!-- end login -->

                      <!-- start password -->
                      <div class="unit">
                          <div class="input login-input">
                              <label class="icon-left" for="password">
                                  <i class="zmdi zmdi-key"></i>
                              </label>
                              <input class="form-control login-frm-input"  type="password" id="password" name="password" placeholder="Password" v-model="credentials.password" @keyup.enter="sendPost()" novalidate>
                      <span class="hint">
                        <router-link to="forgotpassword" class="link">Forgot password?</router-link>
                      </span>
                          </div>
                      </div>
                      <!-- end password -->
                      <div class="unit">
                        <div class="input login-input">
                          <button type="button" class="btn-block btn btn-primary" @click="sendPost()">Sign in</button>
                          <hr/>
                          <p>Is it your first product purchase?</p>
                          <router-link to="register">
                            <button type="button" class="btn-block btn btn-black">Register here if you are a new Customer</button>
                          </router-link>
                        </div>
                      </div>
                      <div class="login-video">
                        <!--<a :href="video" target="_blank"><img src="static/images/login_video.png" class="img-responsive"></a>-->
                        <a :href="video" target="_blank"><img src="static/images/login_video.png" class="img-responsive"></a>
                      </div>
                  </div>
            </form>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
  import auth from '../auth'
  export default {
    data() {
      return {
        loading: false,
        credentials: {
          username: '',
          password: '',
          ref_token: null
        },
        loginErr: '',
        video: null
      }
    },
    async beforeMount() {
      await auth.getSettings(this);

      console.log(localStorage.getItem('promo_redeem_code'))
     
    },
    methods: {
      sendPost() {
        if (this.credentials.username && this.credentials.password){
          this.loading = true
          var credentials = {
            username: this.credentials.username,
            password: this.credentials.password,
            ref_token: localStorage.getItem('ref_token') ? localStorage.getItem('ref_token') : null,
            redeem_code: this.$route.query.redeem_code ? this.$route.query.redeem_code : null
          }
          // We need to pass the component's this context
          // to properly make use of http in the auth service          
            auth.login(this, credentials)
          }

      }
    }

  }
</script>


// WEBPACK FOOTER //
// src/components/Login.vue